import { render, staticRenderFns } from "./DocJobId.vue?vue&type=template&id=971a44da&scoped=true&"
import script from "./DocJobId.vue?vue&type=script&lang=js&"
export * from "./DocJobId.vue?vue&type=script&lang=js&"
import style0 from "./DocJobId.vue?vue&type=style&index=0&id=971a44da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971a44da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import OlTooltip from '@/components/oluetify/OlTooltip.vue'
installComponents(component, {OlTooltip})
